import { Component, OnInit, ViewChild } from '@angular/core';
import { ValueTransformer } from '@angular/compiler/src/util';
import { DatepickerOverviewComponent } from '../components/datepicker-overview/datepicker-overview.component';
import { AuthorsListComponent } from '../components/authors-list/authors-list.component';
import { SelectionModel } from '@angular/cdk/collections';
import { pgiAuthors } from '../models/authors';
import { AuthorsService } from '../shared/authors/authors.service';
import { CalcHeaders } from '../models/calcHeader';
import { MatDialog, MatSnackBar } from '@angular/material';
import { ModalWindowComponent } from '../components/modal-window/modal-window.component';
import { Action } from 'rxjs/internal/scheduler/Action';
import { HashLocationStrategy } from '@angular/common';


@Component({
  selector: 'app-accountant',
  templateUrl: './accountant.component.html',
  styleUrls: ['./accountant.component.css']
})
export class AccountantComponent implements OnInit {

  @ViewChild(AuthorsListComponent)
  private authorsListComponent: AuthorsListComponent;

  @ViewChild(DatepickerOverviewComponent)
  private datepickerOverviewComponent: DatepickerOverviewComponent;
  authors: pgiAuthors[];
  // author: pgiAuthors;
  auth: pgiAuthors;
  selectedAuthor: pgiAuthors;
  message;
  calcHead: CalcHeaders;
  selectedCalcHead: CalcHeaders;

  displayedColumns = ['id', 'month', 'year', 'salesValue', 'provisionValue', 'correction', 'isPublished', 'action'];
  // dataSource: any;

  isLoading = false;
  color = 'primary';
  mode = 'indeterminate';

  accountBalance = 0.00;

  constructor(private authorService: AuthorsService, public dialog: MatDialog, public snackBar: MatSnackBar) {
   }

  ngOnInit() {
  }

  generujNaliczenia() {
    const autor = this.authorsListComponent.selectedValue;
    const dataOd = this.datepickerOverviewComponent.date1;
    const dataDo = this.datepickerOverviewComponent.date2;
    this.auth = null;

    this.getAuthors(autor, dataOd, dataDo);
  }

  getAuthors(name, data1, data2): void {
    this.isLoading = true;
      this.authorService.getAuthorByName(name, data1, data2).subscribe((authors => {
        this.authors = authors;
        this.isLoading = false;
      }));
  }

  onSelect(author: pgiAuthors): void {
    author.pgiCalcHeader.forEach(x => x.authorName = author.authorName);
    this.selectedAuthor = author;
    this.auth = this.selectedAuthor;
    this.calcHead = null;
  }

  onSelectCalc(row): void {
    this.selectedCalcHead = row;
    this.calcHead = this.selectedCalcHead;
    this.auth.accountBalance = this.selectedCalcHead.accountBalance;
  }

  save() {
    this.isLoading = true;
    this.auth.pgiCalcHeader.forEach(h => {
      h.provisionValue += h.correction;
      h.accountBalance = this.auth.accountBalance;
      h.pgiCalcItems.forEach(i => {
      i.provisionValue += i.correction;
      });
    });
    this.authorService.updateAuthor(this.auth).subscribe(
       success => {
        this.isLoading = false;
        this.openSnackBar('Zaktualizowano poprawnie dane dla '  + this.auth.authorName, '');

        const index = this.authors.indexOf(this.auth);
        console.log(index);
        this.authors.splice(index, 1);
        this.auth = null;
    },
       error => this.openSnackBar('Wystąpił błąd:  '  + error, '')
      );
  }

  saveAll() {
    this.isLoading = true;
    this.authors.forEach(a => {
      a.pgiCalcHeader.forEach(h => {
        h.provisionValue += h.correction;
        h.accountBalance = a.accountBalance;
        h.pgiCalcItems.forEach(i => {
          i.provisionValue += i.correction;
          });
      });
    }
    );
    console.log(this.authors);
    this.authorService.addAuthors(this.authors).subscribe(
       success => {
            this.authors = null;
            this.auth = null;
            this.selectedCalcHead = null;
            this.isLoading = false;
            this.openSnackBar('Dodano naliczenia dla wszystkich autorów ', '');
    },
       error => this.message = error
      );
  }

  publishAll() {
    console.log(this.authors);
    this.authors.forEach( a => a.pgiCalcHeader.forEach(h => {
      if (h.isPublished) {
        h.isPublished = false;
      } else {
        h.isPublished = true;
      }
    }  ) );
  }

  onChangeTotalCorrection() {
    this.auth.pgiCalcHeader.forEach(h => {
      h.correction = 0;
      h.pgiCalcItems.forEach(i => {
        h.correction += i.correction;
        this.auth.accountBalance += i.correction;
      });
    });
  }

  openDialog(row): void {
    this.selectedCalcHead = row;
    const dialogRef = this.dialog.open(ModalWindowComponent, {
      width: '80%',
      data: this.selectedCalcHead
    });

    dialogRef.afterClosed().subscribe(result => {
     // this.calcHead = result;
      this.selectedCalcHead = result;
      this.onChangeTotalCorrection();
    });
  }

  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 2000,
      verticalPosition: 'top',
    });
  }

  rozliczAll() {
    this.authorService.clearAllAccountBalance().subscribe(succes => {
      this.authors.forEach(el => {
        if (el.accountBalance > 100) {
          el.accountBalance = 0;
        }
      });
      this.openSnackBar('Kwota została wyzerowana.', '');
    }
    );
  }
  /*rozlicz() {
    this.authorService.clearAccountBalance(this.auth.id).subscribe( succes => {
      this.auth.accountBalance = 0;
      this.openSnackBar('Kwota została wyzerowana.', '');
    }
    );
  }*/
}

